<template>
    <div>
        <!-- 题库练习 -->
        <div class="question-btn" @click="handleGopageBank">
             <img src="@/images/buttonExercise.png" alt="" srcset="">
             <div class="question-title">题库练习</div>
        </div>
        <!-- 灰色线 -->
        <div class="line"></div>
        <!-- 按钮 -->
        <div class="start-btn">
             <span @click="handleGoPagePracticetest">模拟考试</span>
             <span @click="handleGoPageTestRecords">考试记录</span>
        </div>
    </div>
</template>

<script>

import {  PracticeTest,Exercises } from "@/api/training";
import { Toast } from "vant";
export default {
    data() {
        return {

        }
    },
    mounted() {
        
    },
    methods:{
        // 跳转到题库练习
        handleGopageBank() {
            Exercises().then(res => {
                console.log(res)
                if(res.code == 200) {
                    this.$router.push({
                    path:'/answer'
                  })
                }else {
                    Toast(res.message)
                }
            });
        
        },
        // 跳转到模拟考试
        handleGoPagePracticetest() {
            PracticeTest().then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.$router.push({
                            path:'/practicetest'
                    })
                }else {
                  Toast(res.message)
                }
      });
          
        },
        // 跳转考试记录
        handleGoPageTestRecords() {
            this.$router.push({
                path:'/testrecords'
            })
        }
    }

}
</script>

<style scoped lang="scss">
    // 题库练习按钮
    .question-btn {
        width: 100%;
        height: 207px;
        background-color: #ffffff;
        position: relative;
        img {
            width: 123px;
            height: 123px;
            position: absolute;
            top: 50%;
            margin-top: -62px;
            left: 50%;
            margin-left: -62px;

        }
        .question-title {
            width: 123px;
            height: 123px;
            line-height: 123px;
            position: absolute;
            top: 50%;
            margin-top: -72px;
            left: 50%;
            margin-left: -62px; 
            font-size: 16px;
            color: #ffffff;
        }
    
    }
    // 灰色线
    .line {
        width: 100%;
        height: 10px;
        background-color: #F6F6F6;
    }
    // button
     .start-btn {
        width: 350px;
        margin: 0 auto;
        span {
            display:inline-block;
            width: 150px;
            height: 44px;
            border:1px solid #008CFF;
            text-align: center;
            line-height: 44px;
            border-radius: 22px;
            font-size: 16px;
            font-weight: bold;
            color: #008CFF;
            margin:30px 10px;
            &:hover {
                 background: -webkit-linear-gradient(left, #05AEFC, #008CFF);
                 color: #FFFFFF;
            }
        }
    }
</style>
